/**
 * Javascript specific to the Contact US page
 * Show/Hide Regions, Google Map, etc
 */

(function (window, document, $) {
	'use strict';

	window.contactUs = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			contactUs.bind();

			// Only trigger map load if the map container div exists
			if ($( '#locations-map' ).length) {
				contactUs.loadScript();
			}
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {

			/**
			 * Show/Hide the region divs for bios based on selection
			 * NOTE: Bio regions are different than Location regions
			 */
            // North Region Click
            $( '#usa-map .north-division' ).click(
                function () {
                    $('#region-select option[value="north-division"]').prop( 'selected', true );
                    $( '.filterable' ).hide();
                    $('.map-section').removeClass('active');
                    $(this).addClass('active');
                    $( '#north-division' ).show();
                }
            );
            // South Region Click
            $( '#usa-map .south-division' ).click(
                function () {
                    $('#region-select option[value="south-division"]').prop( 'selected', true );
                    $( '.filterable' ).hide();
                    $('.map-section').removeClass('active');
                    $(this).addClass('active');
                    $( '#south-division' ).show();
                }
            );
            // West Region Click
            $( '#usa-map .west-division' ).click(
                function () {
                    $('#region-select option[value="west-division"]').prop( 'selected', true );
                    $( '.filterable' ).hide();
                    $('.map-section').removeClass('active');
                    $(this).addClass('active');
                    $( '#west-division' ).show();
                }
            );
            // Mobile only Filter select
            $( '#region-select' ).change(
                function () {
                    $( '.filterable' ).hide();
                    $( '#' + $( this ).val() ).show();
                }
            );

			/**
			 * Show/Hide location table rows based on selected region and update the map the region's markers
			 * NOTE: Location regions are different than Bio regions
			 */
			$( '#locations-region' ).change(
				function () {
					$( '.location-row' ).hide();
					$( 'tr[data-location-region=' + $( this ).val() + ']' ).show();
					// Trigger the map update
					contactUs.mapInit();
				}
			);
		},

		/**
		 * Build out Google Maps based on Regions
		 */
		mapInit: function () {

			// Setup the map
			window.map = new google.maps.Map(
				document.getElementById( 'locations-map' ), {
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					disableDefaultUI: true,
					zoomControl: true,
					fullscreenControl: true
				}
			);

			// Initialize the 'infowindow' of pop-up for the markers
			var infowindow = new google.maps.InfoWindow();
			// Get the bounds of the map for auto-adjustment later
			var bounds = new google.maps.LatLngBounds();

			// Get the selected location region
			var location_region = $( '#locations-region' ).val();

			// Foreach over the selected table rows and add their locations to the map
			var i = 0;
			$( '#locations-table tr[data-location-region="' + location_region + '"]' ).each(
				function () {
					// Pull the map data we need from the HTML table
					var pop_title          = $( '.location-city', this ).html();
					var popup_address      = $( '.location-address', this ).html();
					var popup_phone        = $( '.location-phone', this ).html();
					var location_latitude  = $( this ).data( 'location-latitude' );
					var location_longitude = $( this ).data( 'location-longitude' );
					// Get the current location's table row HTML
					var current_location_row = $( this ).html();

					// Create the marker
					var marker = new google.maps.Marker(
						{
							position: new google.maps.LatLng( location_latitude, location_longitude ),
							map: map
						}
					);

					// Move the map bounds out each time we add a new marker. This auto-centers the map around all locations.
					bounds.extend( marker.position );

					// Add the pop-up for this marker
					google.maps.event.addListener(
						marker, 'click', (function (marker, i) {
							return function () {
								infowindow.setContent( pop_title + popup_address + popup_phone );
								infowindow.open( map, marker );

								// Load the clicked location table row in the current-location-table
								// DISABLING FOR NOW...
								//$( '#current-location-table' ).html( current_location_row );
							}
						})( marker, i )
					);
					i++;
				}
			);

			// Set the map bounds to what was determined above
            if ( i === 1 ) {
                // Add random point on map in London to force map to zoom out for SA map point
                var myLatLng = new google.maps.LatLng(16.605163, 17.728585);
                bounds.extend( myLatLng );

                // Set map bound tp include new point
                map.fitBounds( bounds );
            } else {
                // If there more than one marker just work like normal
                map.fitBounds( bounds );
            }

            if ( i === 1 ) {
                map.setZoom(14);
            }
		},

		// Async load of the Google Maps API
		loadScript: function () {
			var script  = document.createElement( 'script' );
			script.type = 'text/javascript';
			script.src  = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCjeVHQy9rqAs-8Ou9dnh_rVlH7jiG6qBQ&callback=contactUs.mapInit';
			document.body.appendChild( script );
		},
	};

	contactUs.init();

})( window, document, jQuery );
